/* G&G Dolci 2026: motion and the purchase flow over Dawn 16 (Linea Group, 2026-10-24).
   Everything adds the store's real products to the cart: sets are front-end only, never new products.
   Plain JavaScript, no libraries; motion stops under prefers-reduced-motion. */
(function () {
  'use strict';
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CFG = window.GG || {};
  var CURRENCY = CFG.currency || 'AED';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function money(n) {
    n = Math.round(Number(n) * 100) / 100;
    var fmt = CFG.moneyFormat || (CURRENCY + ' {{amount}}');
    var plain = n % 1 ? n.toFixed(2) : String(n);
    var withCommas = plain.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(amount_no_decimals|amount_with_comma_separator|amount)\s*\}\}/, function (m, k) { return k === 'amount_no_decimals' ? String(Math.round(n)) : withCommas; }).replace(/<[^>]*>/g, '');
  }

  /* ---------- reveal on scroll, with a stagger inside groups ---------- */
  function reveal() {
    $$('[data-gg-stagger]').forEach(function (g) { var flat = g.hasAttribute('data-gg-drift'); $$(':scope > *', g).forEach(function (c, i) { c.style.setProperty('--i', flat ? '0' : String(Math.min(i, 8))); if (!c.classList.contains('gg-rv')) c.classList.add('gg-rv'); }); });
    var els = $$('.gg-rv, .gg-rv-img');
    if (REDUCED || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }
  function hero() { $$('.gg-hero').forEach(function (h) { requestAnimationFrame(function () { requestAnimationFrame(function () { h.classList.add('is-in'); }); }); }); }

  /* ---------- rows pinned while the page scrolls them sideways (phones and tablets) ----------
     Cristian 2026-10-24, "stile Apple": when a row's section reaches the screen it holds still under the header,
     and scrolling down moves the cards sideways until the last one is whole; then the page carries on.
     The whole section holds when it fits the screen, the row alone when only the row fits, nothing on a screen
     too small for the row (it stays a row to swipe). Off on desktop and with reduced motion.
     A phone's address bar comes and goes while the page scrolls, and each time the window changes height. So the
     height a held box must fit in is read once per width, as the SMALL screen (bars showing, 100svh), a change of
     height alone lays nothing out again, and a row is laid out again only when its own plan changes, keeping the
     page where the reader is. The first live version (2026-10-24) did neither: a row held with the bars showing
     and its whole section with them hidden, a held box jumped by half the bar, and every pass took all the rows'
     travel out of the page for a moment, which near the end of the page moved the reader up by thousands of px. */
  function pin() {
    var rows = $$('[data-gg-drift]'); if (!rows.length || REDUCED || !window.matchMedia) return;
    var mq = window.matchMedia('(max-width: 989px)'), items = [], ticking = false, rt, lastW = -1, screenH = 0, force = false;
    rows.forEach(function (r) { var wrap = r.closest('.gg-wrap'), sec = r.closest('.gg-sec'); if (wrap && sec) items.push({ r: r, wrap: wrap, sec: sec, on: false, mode: '', size: '' }); });
    var probe = document.createElement('div');
    probe.setAttribute('aria-hidden', 'true');
    probe.style.cssText = 'position:fixed;left:0;top:0;width:1px;height:100vh;visibility:hidden;pointer-events:none;z-index:-1';
    probe.style.height = '100svh';
    document.body.appendChild(probe);
    function smallScreen() { var s = probe.offsetHeight, w = window.innerHeight; return s && w ? Math.min(s, w) : (s || w); }
    function reset(it) {
      it.wrap.style.position = ''; it.wrap.style.top = ''; it.r.style.position = ''; it.r.style.top = '';
      [it.sec, it.wrap].forEach(function (e) { e.style.height = ''; e.style.boxSizing = ''; }); it.sec.classList.remove('is-pin'); it.r.scrollLeft = 0; it.on = false; it.mode = '';
    }
    function plan(it, h, avail) {
      var dist = it.r.scrollWidth - it.r.clientWidth;
      if (!mq.matches || dist < 8) return null;
      var whole = it.wrap.offsetHeight - (it.on && it.mode === 'row' ? it.dist : 0), rowH = it.r.offsetHeight;
      if (whole <= avail - 16) return { mode: 'section', dist: dist, top: h + Math.round((avail - whole) / 2) };
      if (rowH <= avail - 16) return { mode: 'row', dist: dist, top: h + Math.round((avail - rowH) / 2) };
      return null;
    }
    function apply(it, pl) {
      reset(it);
      if (!pl) return;
      var section = pl.mode === 'section';
      it.box = section ? it.wrap : it.r; it.ref = section ? it.sec : it.wrap; it.spacer = section ? it.sec : it.wrap;
      it.off = section ? (parseFloat(getComputedStyle(it.sec).paddingTop) || 0) : it.r.getBoundingClientRect().top - it.wrap.getBoundingClientRect().top;
      it.spacer.style.boxSizing = 'border-box'; it.spacer.style.height = (it.spacer.offsetHeight + pl.dist) + 'px';
      it.box.style.position = 'sticky'; it.box.style.top = pl.top + 'px';
      it.sec.classList.add('is-pin'); it.dist = pl.dist; it.top = pl.top; it.mode = pl.mode; it.on = true;
    }
    function layout() {
      var w = window.innerWidth, all = force; force = false;
      if (w !== lastW) { lastW = w; screenH = smallScreen(); all = true; }
      if (!all) return;
      var h = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--gg-hdr')) || 0, avail = screenH - h;
      var y = window.scrollY, shift = 0, changed = false;
      items.forEach(function (it) {
        var pl = plan(it, h, avail);
        it.size = it.r.offsetWidth + 'x' + it.r.offsetHeight;
        if (pl ? (it.on && it.mode === pl.mode && it.dist === pl.dist && it.top === pl.top) : !it.on) return;
        var above = it.sec.getBoundingClientRect().bottom <= 0, before = it.on ? it.dist : 0;
        apply(it, pl);
        if (above) shift += (it.on ? it.dist : 0) - before;
        changed = true;
      });
      if (changed && Math.abs(window.scrollY - (y + shift)) > 1) window.scrollTo(0, y + shift);
      frame();
    }
    function frame() {
      ticking = false; var held = false;
      items.forEach(function (it) {
        if (!it.on) return;
        var nat = it.ref.getBoundingClientRect().top + it.off, past = it.top - nat, p = past / it.dist;
        if (past > 0 && past < it.dist + 140) held = true;
        it.r.scrollLeft = Math.round(Math.min(1, Math.max(0, p)) * it.dist);
      });
      // while a row is held on screen, and for 140px after it lets go, the floating WhatsApp button steps aside, so it
      // never covers a card's button (the last card's button is still at the bottom of the screen when the row ends)
      document.documentElement.classList.toggle('gg-pinning', held);
    }
    function req() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    function later(all) { if (all) force = true; clearTimeout(rt); rt = setTimeout(layout, 160); }
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', function () { later(false); });
    if ('ResizeObserver' in window) {
      // a row's own size changing (its pictures or fonts arriving) is the one reason besides the width to look again
      var ro = new ResizeObserver(function () { if (items.some(function (it) { return it.r.offsetWidth + 'x' + it.r.offsetHeight !== it.size; })) later(true); });
      items.forEach(function (it) { ro.observe(it.r); });
    }
    window.addEventListener('load', function () { later(true); });
    layout();
  }

  /* ---------- loops play only on screen ---------- */
  function loops() {
    var vids = $$('video[data-gg-loop]'); if (!vids.length) return;
    if (REDUCED || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) { es.forEach(function (en) { var v = en.target; if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } }); }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---------- header height for sticky offsets ---------- */
  function hdrVar() { var h = $('.section-header'); if (h) document.documentElement.style.setProperty('--gg-hdr', h.offsetHeight + 'px'); }

  /* ---------- the bag: one way in for every add ---------- */
  function bubble() {
    var b = $('#cart-icon-bubble'); if (!b) return;
    b.classList.remove('gg-shake'); void b.offsetWidth; b.classList.add('gg-shake');
    var c = $('.cart-count-bubble', b); if (c) { c.classList.remove('gg-pop'); void c.offsetWidth; c.classList.add('gg-pop'); }
  }
  function fly(img) {
    if (REDUCED || !img) return;
    var target = $('#cart-icon-bubble'); if (!target) return;
    var a = img.getBoundingClientRect(), t = target.getBoundingClientRect();
    if (!a.width) return;
    var f = document.createElement('img'); f.className = 'gg-fly'; f.src = img.currentSrc || img.src; f.alt = '';
    f.style.left = (a.left + a.width / 2 - 32) + 'px'; f.style.top = (a.top + a.height / 2 - 32) + 'px';
    document.body.appendChild(f);
    requestAnimationFrame(function () {
      f.style.transform = 'translate(' + (t.left + t.width / 2 - (a.left + a.width / 2)) + 'px,' + (t.top + t.height / 2 - (a.top + a.height / 2)) + 'px) scale(.25)';
      f.style.opacity = '.4';
    });
    setTimeout(function () { f.remove(); }, 800);
  }
  function btnState(btn, state) {
    if (!btn) return;
    btn.classList.remove('is-loading', 'is-added');
    if (state) btn.classList.add(state);
    if (state === 'is-loading') btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy');
  }
  function closeSheets() { $$('.gg-sheet.is-on').forEach(function (s) { s.classList.remove('is-on'); s.setAttribute('aria-hidden', 'true'); }); var sc = $('.gg-scrim'); if (sc) sc.classList.remove('is-on'); document.documentElement.classList.remove('gg-lock'); }
  function ggAdd(items, btn, img) {
    btnState(btn, 'is-loading');
    var drawer = $('cart-drawer');
    var body = { items: items };
    if (drawer) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = window.location.pathname; }
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) {
          btnState(btn, null);
          var msg = (res.j && (res.j.description || res.j.message)) || 'Please try again';
          if (btn) { var lab = $('.gg-btn__label', btn); var old = lab ? lab.innerHTML : null; if (lab) lab.textContent = msg; setTimeout(function () { if (lab && old !== null) lab.innerHTML = old; }, 2600); }
          return;
        }
        btnState(btn, 'is-added');
        fly(img);
        setTimeout(function () {
          btnState(btn, null);
          closeSheets();
          if (drawer && res.j.sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents({ id: items[0] && items[0].id, sections: res.j.sections });
            setTimeout(function () { drawerEnhance(); bubble(); }, 60);
          } else { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
          if (window.publish && window.PUB_SUB_EVENTS) { try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'gg', cartData: res.j }); } catch (e) { /* the drawer is already painted */ } }
        }, REDUCED ? 0 : 650);
      })
      .catch(function () { btnState(btn, null); });
  }
  window.ggAdd = ggAdd;

  /* ---------- free delivery bar in the drawer: fill from where it was ---------- */
  var lastPct = 0;
  function drawerEnhance() {
    var fr = $('#CartDrawer .gg-free'); if (!fr) return;
    var bar = $('.gg-free__bar i', fr), p = Number(fr.getAttribute('data-pct') || 0);
    if (bar) { bar.style.setProperty('--p', lastPct + '%'); requestAnimationFrame(function () { requestAnimationFrame(function () { bar.style.setProperty('--p', p + '%'); }); }); }
    lastPct = p;
  }
  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest('#cart-icon-bubble'); if (cartLink) setTimeout(drawerEnhance, 50);
  });

  /* ---------- pickers: option cards with price and compare-at, quantity, add ---------- */
  function animateNumber(el, to) {
    if (!el) return; var from = Number(el.getAttribute('data-v') || to); el.setAttribute('data-v', String(to));
    if (REDUCED || from === to) { el.textContent = money(to); return; }
    var t0 = performance.now(), d = 420;
    function step(t) { var k = Math.min(1, (t - t0) / d); var e = 1 - Math.pow(1 - k, 3); el.textContent = money(k < 1 ? Math.round(from + (to - from) * e) : to); if (k < 1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  function paintPrice(box, now, was) {
    if (!box) return;
    var n = $('.gg-price__now', box), w = $('.gg-price__was', box), s = $('.gg-price__save', box);
    animateNumber(n, now);
    if (w) { if (was > now) { w.textContent = money(was); w.hidden = false; } else { w.hidden = true; } }
    if (s) { if (was > now) { s.textContent = 'Save ' + money(was - now); s.hidden = false; s.classList.remove('is-bump'); void s.offsetWidth; s.classList.add('is-bump'); } else { s.hidden = true; } }
  }
  function initPicker(pk) {
    var q = 1, qv = $('[data-gg-qty]', pk), btn = $('[data-gg-add-picker]', pk);
    function cur() { return $('input[type=radio]:checked', pk); }
    function upd() {
      var c = cur(); if (!c) return;
      var p = Number(c.getAttribute('data-price')), w = Number(c.getAttribute('data-was') || 0);
      paintPrice($('[data-gg-price]', pk) || $('[data-gg-price="' + pk.id + '"]'), p, w);
      $$('[data-gg-price-for="' + pk.id + '"]').forEach(function (b) { paintPrice(b, p, w); });
      $$('[data-gg-bp]', pk).concat($$('[data-gg-bp-for="' + pk.id + '"]')).forEach(function (bp) { bp.textContent = money(p * q); });
      var sv = $('[data-gg-serves]', pk); if (sv) sv.textContent = c.getAttribute('data-note') || '';
      $$('[data-gg-variant-name-for="' + pk.id + '"]').forEach(function (x) { x.textContent = (q > 1 ? q + ' \u00d7 ' : '') + (c.getAttribute('data-label') || ''); });
    }
    pk.addEventListener('change', upd);
    $$('[data-gg-step]', pk).forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); q = Math.max(1, Math.min(20, q + Number(b.getAttribute('data-gg-step')))); if (qv) qv.textContent = String(q); upd(); }); });
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault(); var c = cur(); if (!c || c.disabled) return;
      var pdp = pk.closest('.gg-pdp'); var img = $('.gg-sheet__img', pk) || (pdp && $('.gg-gal__s img', pdp)) || $('img', pk);
      ggAdd([{ id: Number(c.value), quantity: q }], btn, img);
      q = 1; if (qv) qv.textContent = '1'; setTimeout(upd, 900);
    });
    upd();
  }

  /* ---------- quick-add sheets ---------- */
  var lastFocus = null;
  function openSheet(id, opener) {
    var s = document.getElementById(id); if (!s) return;
    closeSheets(); lastFocus = opener || document.activeElement;
    var sc = $('.gg-scrim'); if (sc) sc.classList.add('is-on');
    s.classList.add('is-on'); s.setAttribute('aria-hidden', 'false');
    var f = $('input[type=radio]:checked', s) || $('button', s); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 60);
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-gg-quick]'); if (o) { e.preventDefault(); openSheet(o.getAttribute('data-gg-quick'), o); return; }
    if (e.target.closest('[data-gg-close]') || e.target.classList.contains('gg-scrim')) { closeSheets(); if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); return; }
    var a = e.target.closest('[data-gg-add]');
    if (a) { e.preventDefault(); var img = $('img', a.closest('[data-gg-row]') || a.parentNode); ggAdd([{ id: Number(a.getAttribute('data-gg-add')), quantity: 1 }], a, img); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && $('.gg-sheet.is-on')) closeSheets(); });

  /* ---------- sets: choose, see the price, add the real products ---------- */
  document.addEventListener('click', function (e) {
    var m = e.target.closest('[data-gg-more]'); if (!m) return;
    e.preventDefault(); var sl = m.closest('.gg-set__slot'); if (sl) sl.classList.add('is-open'); m.setAttribute('aria-expanded', 'true');
  });
  function initSet(set) {
    var btn = $('[data-gg-add-set]', set), mode = set.getAttribute('data-mode'), val = Number(set.getAttribute('data-value') || 0);
    function chosen() { return $$('.gg-set__slot', set).map(function (sl) { return $('input:checked', sl) || $('input', sl); }).filter(Boolean); }
    function upd() {
      var picks = chosen(), sum = 0, last = 0;
      picks.forEach(function (p, i) { var pr = Number(p.getAttribute('data-price')); sum += pr; if (i === picks.length - 1) last = pr; });
      var gift = $('[data-gg-gift]', set), giftVal = gift ? Number(gift.getAttribute('data-price') || 0) : 0;
      var now = mode === 'percent-last' ? sum - last * val / 100 : (mode === 'percent-all' ? sum * (100 - val) / 100 : (mode === 'fixed-price' ? val : sum - val));
      now = Math.round(now * 100) / 100; // to the fils, as the discount will charge it at checkout
      paintPrice($('[data-gg-price]', set), now, sum + giftVal);
      var bp = $('[data-gg-bp]', set); if (bp) bp.textContent = money(now);
      set.setAttribute('data-now', String(now));
      $$('.gg-pick label', set).forEach(function (l) { var r = $('input', l); l.classList.toggle('is-picked', !!(r && r.checked)); });
      var img = $('.gg-set__img', set); var lead = picks[0] && picks[0].getAttribute('data-img');
      if (img && lead && set.hasAttribute('data-follow-img') && img.getAttribute('src') !== lead) { img.style.opacity = '0'; setTimeout(function () { img.src = lead; img.removeAttribute('srcset'); img.style.opacity = '1'; }, 180); }
    }
    set.addEventListener('change', upd);
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault();
      var items = chosen().map(function (p) { return { id: Number(p.value), quantity: 1 }; });
      var gift = $('[data-gg-gift]', set); if (gift) items.push({ id: Number(gift.getAttribute('data-variant')), quantity: 1 });
      ggAdd(items, btn, $('.gg-set__img', set));
    });
    upd();
  }

  /* ---------- the bundle of three on a product page ----------
     This dessert in the size chosen above, two more in a size of their own; a box unticked leaves the bag and
     dims its picture; the saving shows only when all three are in, to the fils, as the checkout discount charges it. */
  /* The trio box price as the checkout charges it (2026-10-26, tested in the live cart). When two ticked pieces also
     make one of the sets below, Shopify gives them the set's automatic discount and the 10% falls on the third piece
     only. This list mirrors the set discounts in the admin (Discounts, "buy 1 get 1 with AED n off"): change one there,
     change it here. The order is the one Shopify follows when two sets fit the same three: the Gold Pair before the
     Duo, the Duo before the Pistachio Pair. */
  var GG_PAIRS = [
    { buy: [41426364891230], get: [41426364006494], off: 35 },                // The Gold Pair
    { buy: [41426364006494], get: [41426365546590], off: 37 },                // The Tiramisù Duo
    { buy: [41426365546590], get: [41660354887774], off: 45 },                // The Pistachio Pair
    { buy: [41657745899614], get: [41660303310942], off: 33 },                // The Fruit Pair
    { buy: [41245063413854, 41245109780574], get: [41426364006494, 41426364891230, 41426365546590], pct: 25 }, // Panettone and Tiramisù
    { buy: [41245109813342], get: [41245063446622], off: 30 },                // The Panettone Pair
    { buy: [41245109780574], get: [41245063413854], off: 31 },                // The Little Pair
    { buy: [41675733696606], get: [41937403052126], off: 37 },                // Afternoon Tea
    { buy: [41936306012254], get: [41657745899614], off: 39 },                // The Dinner Party
    { buy: [41995225006174], get: [41675733696606], off: 41 }                 // The Family Table
  ];
  function fbtTotal(on, pct, all) {
    var sum = 0; on.forEach(function (x) { sum += x.price; });
    for (var r = 0; r < GG_PAIRS.length; r++) {
      var p = GG_PAIRS[r];
      for (var i = 0; i < on.length; i++) for (var j = 0; j < on.length; j++) {
        if (i === j || p.buy.indexOf(on[i].id) < 0 || p.get.indexOf(on[j].id) < 0) continue;
        var off = p.off != null ? p.off : Math.round(on[j].price * p.pct) / 100, rest = 0;
        on.forEach(function (x, k) { if (k !== i && k !== j) rest += x.price; });
        return Math.round((sum - off - (all ? Math.round(rest * pct) / 100 : 0)) * 100) / 100;
      }
    }
    return all ? Math.round(sum * (100 - pct)) / 100 : sum;
  }
  function initFbt(box) {
    var pct = Number(box.getAttribute('data-pct') || 10), btn = $('[data-gg-fbt-add]', box), pk = document.getElementById(box.getAttribute('data-anchor') || '');
    var rows = $$('[data-gg-fbt-item]', box), pics = $$('[data-gg-fbt-pic]', box), label = $('[data-gg-fbt-label]', box), note = $('[data-gg-fbt-note]', box);
    function read(it) {
      var sel = $('[data-gg-fbt-v]', it), o = sel ? sel.options[sel.selectedIndex] : null;
      return { on: $('[data-gg-fbt-on]', it).checked, id: Number(o ? o.value : it.getAttribute('data-v')), price: Number(o ? o.getAttribute('data-price') : it.getAttribute('data-price')) };
    }
    function upd() {
      var list = rows.map(read), sum = 0, n = 0, full = 0;
      list.forEach(function (x, i) {
        full += x.price; if (x.on) { sum += x.price; n++; }
        var pp = $('[data-gg-fbt-p]', rows[i]); if (pp) pp.textContent = money(x.price);
        rows[i].classList.toggle('is-off', !x.on); if (pics[i]) pics[i].classList.toggle('is-off', !x.on);
      });
      var all = n === list.length, now = fbtTotal(list.filter(function (x) { return x.on; }), pct, all);
      paintPrice($('[data-gg-price]', box), now, sum);
      if (label) label.innerHTML = n === 0 ? 'Choose at least one' : (all ? 'Add all three · ' : (n === 2 ? 'Add both · ' : 'Add to bag · ')) + (n ? '<span>' + money(now) + '</span>' : '');
      if (btn) btn.disabled = n === 0;
      if (note) { if (all) { note.hidden = true; } else { note.hidden = false; note.textContent = 'Choose all three to save ' + money(Math.round((full - fbtTotal(list, pct, true)) * 100) / 100) + '.'; } }
    }
    box.addEventListener('change', upd);
    if (pk) pk.addEventListener('change', function () {
      var r = $('input[type=radio]:checked', pk), a = $('[data-gg-fbt-item][data-anchor]', box); if (!r || !a) return;
      a.setAttribute('data-v', r.value); a.setAttribute('data-price', r.getAttribute('data-price'));
      var sz = $('[data-gg-fbt-size]', a); if (sz && r.getAttribute('data-label')) sz.textContent = r.getAttribute('data-label');
      upd();
    });
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault();
      var items = rows.map(read).filter(function (x) { return x.on; }).map(function (x) { return { id: x.id, quantity: 1 }; });
      if (items.length) ggAdd(items, btn, $('[data-gg-fbt-pic] img', box));
    });
    upd();
  }

  /* ---------- product page: gallery, sticky add bar ---------- */
  function initGallery(g) {
    var s = $('.gg-gal__s', g), n = $('.gg-gal__n', g), k = s ? s.children.length : 0; if (!s) return;
    var th = $$('.gg-gal__t button', g.parentNode);
    function idx() { return Math.round(s.scrollLeft / s.clientWidth); }
    s.addEventListener('scroll', function () { var i = idx(); if (n) n.textContent = (i + 1) + ' / ' + k; th.forEach(function (b, j) { b.classList.toggle('is-on', i === j); }); }, { passive: true });
    $$('.gg-gal__b', g).forEach(function (b) { b.addEventListener('click', function () { s.scrollBy({ left: Number(b.getAttribute('data-dir')) * s.clientWidth, behavior: REDUCED ? 'auto' : 'smooth' }); }); });
    th.forEach(function (b, i) { b.addEventListener('click', function () { s.scrollTo({ left: i * s.clientWidth, behavior: REDUCED ? 'auto' : 'smooth' }); }); });
  }
  function initSticky(bar) {
    var watch = document.getElementById(bar.getAttribute('data-watch')); if (!watch) return;
    // on scroll rather than an IntersectionObserver: a jump straight past the buy block (an anchor, a
    // restored scroll position) never crosses it, and the observer would leave the bar hidden
    var queued = false;
    // gg-buy-in: the buy block is on screen, so the WhatsApp button steps aside and never covers prices or sizes
    function check() { queued = false; var r = watch.getBoundingClientRect(); bar.classList.toggle('is-on', r.bottom < 0); document.documentElement.classList.toggle('gg-buy-in', r.bottom > 0 && r.top < window.innerHeight); }
    window.addEventListener('scroll', function () { if (!queued) { queued = true; requestAnimationFrame(check); } }, { passive: true });
    check();
    var b = $('[data-gg-click]', bar); if (b) b.addEventListener('click', function (e) { e.preventDefault(); var t = document.querySelector(b.getAttribute('data-gg-click')); if (t) t.click(); });
  }

  /* ---------- collection chips ---------- */
  function initChips(ch) {
    ch.addEventListener('click', function (e) {
      var c = e.target.closest('[data-filter]'); if (!c) return;
      $$('[data-filter]', ch).forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
      var v = c.getAttribute('data-filter'), grid = document.getElementById(ch.getAttribute('data-grid'));
      $$('[data-tags]', grid).forEach(function (card, i) {
        var show = v === 'all' || (' ' + card.getAttribute('data-tags') + ' ').indexOf(' ' + v + ' ') >= 0;
        card.classList.toggle('is-hidden', !show);
        if (show && !REDUCED) { card.classList.remove('is-in'); card.style.setProperty('--i', String(i % 8)); requestAnimationFrame(function () { card.classList.add('is-in'); }); }
      });
    });
  }

  function init() {
    window.ggReady = true;
    document.documentElement.classList.add('gg-js');
    hdrVar(); window.addEventListener('resize', hdrVar);
    reveal(); hero(); loops(); pin();
    $$('[data-gg-picker]').forEach(initPicker);
    $$('[data-gg-set]').forEach(initSet);
    $$('[data-gg-fbt]').forEach(initFbt);
    $$('.gg-gal').forEach(initGallery);
    $$('.gg-sbar[data-watch]').forEach(initSticky);
    $$('[data-gg-chips]').forEach(initChips);
    drawerEnhance();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(hdrVar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
